import React from 'react';
import { Heading } from '../../components';
import css from '../../containers/ListingPage/ListingPage.module.css';

import { GiVacuumCleaner } from 'react-icons/gi';
import { FaWind } from 'react-icons/fa6';
import { MdCleanHands } from 'react-icons/md';
import { SiCcleaner } from 'react-icons/si';

const cleaningDisplayData = {
  daily: {
    name: 'Daily Cleaning and Disinfection',
    icon: <SiCcleaner />,
  },
  twice: {
    name: 'Twice-Daily Cleaning',
    icon: <GiVacuumCleaner style={{ fontSize: '20px' }} />,
  },
  odor: {
    name: 'Odor Control Measures',
    icon: <FaWind />,
  },
  pet_safe: {
    name: 'Pet-Safe Cleaning Products',
    icon: <MdCleanHands />,
  },
};

const SectionCleaningFacilities = props => {
  const { heading, selectedOptions = [] } = props;
  if (!heading || selectedOptions.length === 0) {
    return null;
  }

  return (
    // <section className={css.sectionCleaningFacilities}>
    //   <Heading as="h2" rootClassName={css.sectionHeading}>
    //     {heading}
    //   </Heading>
    //   <ul className={css.cleaningFacilitiesList}>
    //     {selectedOptions.map(option => {
    //       const facility = cleaningDisplayData[option];
    //       return (
    //         <li key={option} className={css.multiEnumItem}>
    //           <span className={css.facilityIcon}>{facility?.icon}</span>
    //           <span>{facility?.name || option}</span>
    //         </li>
    //       );
    //     })}
    //   </ul>
    // </section>
    <section className={css.sectionCleaningFacilities}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>

      <ul className={css.cleaningFacilitiesList}>
        <li className={css.multiEnumItem}>
          <span className={css.facilityIcon}>
            <SiCcleaner />
          </span>
          <span>Daily Cleaning and Disinfection</span>
        </li>
      </ul>
    </section>
  );
};

export default SectionCleaningFacilities;
